/**
 * Textos do histórico do caso (E137.F3, GUS-160, ADR-0093): a trilha encadeada do caso, só da
 * equipe. Cada fato tem um rótulo neutro; a verificação diz se a trilha está íntegra ou o que foi
 * alterado, removido ou posto fora de ordem.
 */
export const ptBRHistorico = {
  titulo: 'Histórico do caso',
  subtitulo: 'O que aconteceu no caso, em ordem, com quem agiu e o registro de cada etapa.',
  voltar: 'Voltar ao caso',
  carregando: 'Carregando o histórico…',
  erro: 'Não foi possível carregar o histórico. Tente novamente.',
  semPermissao: 'O histórico do caso é da equipe que atende o caso.',
  vazio: 'Ainda não há registros neste caso.',
  plataforma: 'Plataforma',
  registro: 'Registro {seq}',
  verificacao: {
    titulo: 'Verificação da trilha',
    integra: 'Íntegra: {n} registro(s), cada um ligado ao anterior.',
    violada: 'A trilha tem registro alterado, removido ou fora de ordem.',
    vazia: 'Ainda não há registros a verificar.',
    problema: {
      alterado: 'O registro {seq} não reproduz o que foi gravado.',
      removido: 'Falta registro antes do {seq}.',
      fora_de_ordem: 'O registro {seq} não aponta para o anterior.',
    },
    limite:
      'A verificação mostra alteração, remoção e troca de ordem. Sem âncora externa, a reescrita inteira da trilha por quem administra a infraestrutura não é detectada.',
  },
  tipo: {
    recebimento_selado: 'Recebimento selado',
    conferencia_registrada: 'Conferência de integridade',
    ocorrencia_aberta: 'Ocorrência de custódia aberta',
    ocorrencia_resolvida: 'Ocorrência de custódia resolvida',
    exame_verificado: 'Verificação do documento',
    evento_corrigido: 'Correção de registro',
    laudo_editado: 'Laudo editado',
    narrativa_gerada: 'Texto do laudo preparado',
    narrativa_aprovada: 'Texto do laudo aprovado',
    narrativa_reaberta: 'Texto do laudo reaberto',
    pre_analise_executada: 'Análise preliminar executada',
    documento_emitido: 'Documento emitido',
    laudo_assinado: 'Laudo assinado',
    documento_conferido: 'Arquivo conferido',
    documento_divergente: 'Entrega recusada: arquivo guardado não confere',
    ficha_da_leitura_gravada: 'Leitura dos documentos registrada',
    leitura_conferida: 'Leitura conferida',
    leitura_retomada: 'Leitura refeita',
    limitacao_da_leitura_registrada: 'Limitação da leitura registrada',
    fotografia_recortada: 'Recorte da fotografia ajustado',
    pedido_atualizado: 'Prazo, urgência ou observação do pedido atualizados',
    acesso_por_qr_emitido: 'Link de acesso pelo QR gerado',
    acesso_por_qr_revogado: 'Link de acesso pelo QR cancelado',
    arquivo_recusado: 'Arquivo não recebido',
    etapa_conferida: 'Etapa conferida',
    etapa_retomada: 'Consulta feita de novo a pedido da equipe',
    limitacao_da_etapa_registrada: 'Consulta registrada como não disponível',
    assinatura_reconciliada: 'Assinatura repetida: mantida a já registrada',
    // E149.F1 (GUS-149, ADR-0102 §3.5): uma mensagem da conversa do caso; o texto fica na conversa.
    mensagem_do_caso: 'Mensagem na conversa do caso',
    // E155.F1 (GUS-192, ADR-0105 §2.5): uma informação revista na fonte; o valor fica no registro.
    leitura_revista: 'Informação revista na fonte',
    // E165.F1.T06 (GUS-105, ADR-0114 §2): a pessoa escolheu vincular o envio a este caso.
    envio_vinculado: 'Envio vinculado por escolha do usuário',
    // E170.F1.C02 (GUS-229, ADR-0123): a certificação revogada; o motivo fica na revogação.
    certificacao_revogada: 'Certificação revogada',
    // E177.F1 (GUS-253 A1, ADR-0131): o banco do processo, pela leitura da CCB ou pela mesa.
    origem_informada: 'Banco do caso informado',
    // E177.F3 (GUS-253, ADR-0130 §2.6): a CCB informada mantida, diferente do número lido.
    ccb_divergente_mantida: 'Número da CCB mantido, diferente do lido no documento',
    // E184.F4 (GUS-145 item 5, ADR-0136 §4): a análise morfológica refeita sobre o par eleito.
    analise_morfologica_refeita: 'Análise morfológica refeita',
    // E203.F4 (ADR-0146 §6–§9): o perito revê um dado pelo painel do documento, com fundamento.
    dado_revisto: 'Dado revisto pelo perito, com fundamento',
    // E214.F1 (GUS-314): o perito recortou uma área de uma página e disse o que ela é.
    documento_recortado: 'Área de documento recortada pelo perito',
    // E216.F4 (GUS-317 item 3): o arquivo excluído da análise na aba Documentos.
    documento_excluido: 'Arquivo excluído da análise pelo perito',
    // E224.F2 (ADR-0151 §5): a equipe cancelou o caso; o caso parou.
    caso_cancelado: 'Caso cancelado pela equipe',
  },
  detalhe: {
    envioVinculado: 'Do envio {codigo}',
    origemBanco: 'Banco: {banco}',
    origemEscritorio: 'Escritório requerente: {escritorio}',
    origemPelaLeitura: 'Identificado pela leitura da CCB (CNPJ do credor)',
    origemPelaEquipe: 'Informado pela equipe',
    // E177.F1.C02 (GUS-253 item 1): a reavaliação devolve a pendente o banco que a leitura não confirma.
    origemRetirada: 'Banco retirado: {banco}',
    origemPelaReavaliacao: 'A leitura da CCB não confirma o credor; a equipe informa o banco',
    ccbInformada: 'CCB informada: {numero}',
    ccbLida: 'Lido no documento: {lida}',
    morfologicaNova: 'Resultado novo: {resultado}',
    morfologicaAnterior: 'Resultado anterior, no histórico: {resultado}',
    dadoRevisto: {
      credito: 'Leitura do comprovante de crédito, com o documento e a página da fonte',
      linha: 'Resultado de uma linha da conferência',
      risco: 'Grau e fato de um risco',
      instante: 'Instante da assinatura',
      modalidade: 'Modalidade da operação',
      cadastro: 'Cadastro do caso',
      protocolo: 'Protocolo de assinatura',
      codigo: 'Código declarado de um documento',
    },
    dadoRevistoNaTabela: 'O valor anterior e o fundamento ficam no registro da revisão',
    documentoRecortado: 'Página {pagina}: área de {w}% × {h}% a partir de {x}%, {y}%',
    destinoDoRecorte: {
      identidade_frente: 'Destino: documento de identidade (frente), para a comparação facial',
      identidade_verso: 'Destino: documento de identidade (verso), para a leitura dos dados',
      selfie: 'Destino: Selfie/FotoDocContrato da formalização, para a comparação facial',
      comprovante_ted: 'Destino: comprovante de TED, para a leitura do crédito',
    },
    recorteDoOriginal: 'Recorte {recorte}; original {original}, sem alteração',
    // E216.F4: o arquivo, o SHA-256 guardado, o motivo e o fundamento da exclusão.
    arquivoExcluido: 'Arquivo {arquivo}; SHA-256 {sha}, guardado sem alteração',
    // E224.F2: o motivo que a equipe escreveu ao cancelar o caso.
    motivoDoCancelamento: 'Motivo: {motivo}',
    motivoDaExclusao: {
      repetido: 'Motivo: arquivo repetido',
      outra_transacao: 'Motivo: arquivo de outro caso ou de outra transação',
      copia_sem_hash: 'Motivo: cópia sem hash declarado no arquivo de evidências',
      outro: 'Motivo: outro',
    },
    fundamentoDaExclusao: 'Fundamento: {fundamento}',
    resultadoDaMorfologia: {
      compativel: 'compatível',
      inconclusivo: 'inconclusivo',
      divergente: 'divergente',
      nao_avaliavel: 'não avaliável',
    },
    manifesto: 'Manifesto {sha}',
    arquivosNovos: '{n} arquivo(s) novo(s)',
    retentativa: 'Sem arquivo novo: repetição de um envio, não um complemento.',
    complemento: 'Complemento do envio anterior',
    conferencia: '{conferem} de {total} conferem',
    situacao: {
      diverge: 'Diverge do registro do recebimento',
      ausente: 'Arquivo não encontrado',
    },
    acao: {
      restaurado: 'Restaurado',
      retirado_do_exame: 'Retirado do exame',
      reenviado_pelo_banco: 'Reenviado pelo banco',
    },
    regua: 'Régua {regua}',
    hashDeclarado: 'Código declarado: {situacao}',
    situacaoDoCodigo: {
      confere: 'confere',
      nao_confere: 'não confere',
      nao_executado: 'não conferível',
      ausente: 'não informado',
    },
    fonte: {
      protocolo: 'fonte: protocolo de assinatura',
      tela_impressa: 'fonte: tela impressa do sistema do banco',
      perito: 'fonte: informado pelo perito',
    },
    consultas: '{n} consulta(s) externa(s), versão não fornecida',
    resultado: 'Resultado {sha}',
    versaoNaoFornecida: 'Serviço externo: versão detalhada não fornecida',
    campo: 'Campo {campo}',
    revisao: 'Revisão {n}',
    origem: {
      manual: 'edição manual',
      agent_proposed: 'proposta revista na conversa',
      edicao_direta: 'edição direta',
    },
    // E171.F3.C02 (GUS-145, reteste de 25/10): a edição do editor manual, com a saída, o trecho, a
    // versão do texto e o fundamento.
    saidaDaEdicao: { exame: 'Exame', riscos: 'Relatório de risco' },
    acaoDaEdicao: {
      substituir: 'reescrito',
      remover: 'tirado do documento',
      restaurar: 'voltou ao original',
      escrever: 'nota escrita',
    },
    versaoDoTexto: 'texto {depois} (antes: {antes})',
    // E184.F1 (GUS-145 item 1): a versão da análise em que a edição foi gravada.
    analiseDaEdicao: 'gravada na análise versão {n}',
    textoOriginal: 'original',
    fundamentoDaEdicao: 'Fundamento: {texto}',
    documento: '{nome} · {sha}',
    assinatura: 'Documento assinado {sha}',
    revogada: 'Documento revogado {sha}',
    // E170.F1.T06 (GUS-229): a forma da assinatura, distinta, na trilha.
    formaDaAssinatura: {
      interna_registrada: 'Registro na plataforma, sem certificado ICP-Brasil',
      icp_brasil: 'Assinatura digital com certificado ICP-Brasil',
    },
    corrige: 'Corrige o registro {seq}: {motivo}',
    conferido: '{resultado} · apresentado {sha}',
    resultadoDaConferencia: {
      corresponde: 'Corresponde ao código registrado',
      diverge: 'Não corresponde ao código registrado',
      sem_referencia: 'Sem código registrado para a versão',
    },
    referencia: 'Versão {versao} · registrado {sha}',
    versaoDoAcesso: 'Versão {versao}',
    divergente: 'Registrado {registrado} · encontrado {encontrado}',
    leitura: 'Versão {versao} · {campos} informações · {sha}',
    conferenciaDaLeitura: 'Leitura versão {ficha} · {estado} · {falhas} pendência(s) técnica(s)',
    retomada: '{n} pendência(s) técnica(s) · {origem}',
    origemDaRetomada: {
      automatica: 'pelo sistema',
      equipe: 'pela equipe',
    },
    limitacaoNaPagina: 'Página {pagina} do arquivo recebido',
    limitacaoSemPagina: 'Pendência sem página',
    estadoDaConferencia: {
      aprovada: 'liberada para a análise',
      corrigir: 'em recuperação',
      bloqueada: 'aguarda a equipe',
    },
    // E141.F1 (ADR-0079 E.26): o ajuste do recorte ou do giro pelo perito.
    grupoDaFoto: {
      documento_identidade: 'Fotografia do documento de identidade',
      ccb: 'Fotografia do titular',
    },
    recorteCaixa: 'Caixa de {w}% × {h}% do original, a partir de {x}%, {y}% · giro {giro}°',
    recorteSoGiro: 'Imagem inteira · giro {giro}°',
    recorteDesfeito: 'Recorte desfeito: imagem inteira, sem giro',
    // E144.F3: o pedido do cliente como ficou.
    prazoDoPedido: 'Prazo processual: {prazo}',
    semPrazo: 'Sem prazo processual informado',
    urgenciaPedida: 'Urgência solicitada: {motivo}',
    semUrgencia: 'Sem pedido de urgência',
    observacaoDoPedido: 'Observação: {texto}',
    // E147.F1 (ADR-0101): a conferência de uma etapa do exame, gravada quando muda.
    etapaConferida: '{etapa} · {liberacao} · versão {versao}',
    etapaDoFluxo: {
      recebimento: 'Recebimento',
      extracao: 'Leitura',
      analise: 'Análise',
      // E209.F2.T05 (GUS-296 item 7c): a etapa entrou no fluxo depois deste mapa e caía em "—".
      resultado: 'Resultado auditado',
      revisao: 'Revisão',
      composicao: 'Composição',
      assinatura: 'Assinatura',
      entrega: 'Entrega',
    },
    liberacaoDaEtapa: {
      aprovado: 'liberada',
      corrigir: 'a corrigir',
      bloqueado: 'travada',
    },
    // E147.F2 (ADR-0101 §2.5–§2.6): o pedido da equipe sobre a consulta e a assinatura repetida.
    consultaDoPedido: 'Análise · {consulta}',
    consultaPorProvedor: {
      lemit: 'base cadastral externa', // branding:allow — chave do contrato do servidor, não exibida
      geocoder: 'localização dos endereços',
      ip_intel: 'classificação dos endereços de rede',
      mapa: 'mapas da localização',
      portal: 'conferência no portal da plataforma',
    },
    assinaturaReconciliada: 'Arquivo assinado {sha}',
    mensagemDoCaso: '{tipo}, pelo lado {lado}',
    tipoDaMensagem: {
      mensagem: 'Mensagem',
      pedido_de_material: 'Pedido de documento',
      resposta_ao_pedido: 'Resposta ao pedido de documento',
      complemento: 'Documento complementar',
      questionamento: 'Questionamento',
      resposta_ao_questionamento: 'Resposta ao questionamento',
      apontamento: 'Apontamento de campo',
      resposta_ao_apontamento: 'Resposta ao apontamento',
      ciencia: 'Ciência registrada',
    },
    ladoDaMensagem: { cliente: 'do cliente', equipe: 'da equipe' },
    // E155.F1 (GUS-192, ADR-0105 §2.5): a informação revista na fonte, pelo nome da ficha; o valor
    // e o motivo ficam no registro cifrado, nunca na trilha.
    leituraRevista: '{campo} · {resultado} · {origem}',
    pecasReabertas: '{n} documento(s) reaberto(s) para nova verificação',
    resultadoDaReleitura: {
      mudou: 'o valor usado no exame mudou',
      sem_mudanca: 'sem mudança',
      ambigua: 'mais de um valor impresso',
      nao_localizado: 'não localizado na fonte',
    },
    origemDaReleitura: {
      releitura: 'pela leitura do sistema',
      correcao_humana: 'confirmado pela equipe',
    },
  },
  corrigir: {
    abrir: 'Corrigir registro',
    motivo: 'O que estava errado neste registro',
    explica: 'A correção entra como registro novo, ligado a este. O registro original não muda.',
    salvar: 'Registrar correção',
    salvando: 'Registrando…',
    cancelar: 'Cancelar',
    erro: 'Não foi possível registrar a correção. Tente novamente.',
  },
} as const;
